import * as Yup from 'yup'

import { formatNumber } from '../../../../helpers/numbers'

import { OBJECTIVE } from '../../CampaignForms/fields'
import {
  LIST_ITEM_OPTION,
  OPTION_EXISTING_LIST_ITEM,
  OPTION_NEW_LIST_ITEM
} from '../../../../hooks/formHooks/listItemFormHooks/fields'
import {
  CAMPAIGN_NAME_CONVENTION_OPTION,
  CAMPAIGN_NAME_OPTION,
  CUSTOM_CAMPAIGN_NAME,
  CUSTOM_CAMPAIGN_NAME_OPTION,
  EXPECTED_START_DATE,
  OPTIONAL_TAG,
  SHORT_CAMPAIGN_DESCRIPTION
} from './Steps/CampaignNameStep/CampaignNameFields/fields'

export const CAMPAIGN = 'campaign'

export const getCampaignInitialValues = isCampaignsExist => ({
  // campaign
  [LIST_ITEM_OPTION]: isCampaignsExist ? OPTION_EXISTING_LIST_ITEM : OPTION_NEW_LIST_ITEM,
  [CAMPAIGN]: '',
  [CAMPAIGN_NAME_OPTION]: CAMPAIGN_NAME_CONVENTION_OPTION,
  [SHORT_CAMPAIGN_DESCRIPTION]: '',
  [EXPECTED_START_DATE]: '',
  [OPTIONAL_TAG]: ''
})

export const campaignValidation = {
  [CAMPAIGN]: Yup.string().when(LIST_ITEM_OPTION, {
    is: OPTION_EXISTING_LIST_ITEM,
    then: () => Yup.string().required('Please select campaign')
  }),
  [SHORT_CAMPAIGN_DESCRIPTION]: Yup.string().when([CAMPAIGN_NAME_OPTION, LIST_ITEM_OPTION], {
    is: (campaignNameOption, listItemOption) =>
      campaignNameOption === CAMPAIGN_NAME_CONVENTION_OPTION && listItemOption === OPTION_NEW_LIST_ITEM,
    then: () => Yup.string().required('Please enter short campaign description')
  }),
  [EXPECTED_START_DATE]: Yup.date().when([CAMPAIGN_NAME_OPTION, LIST_ITEM_OPTION], {
    is: (campaignNameOption, listItemOption) =>
      campaignNameOption === CAMPAIGN_NAME_CONVENTION_OPTION && listItemOption === OPTION_NEW_LIST_ITEM,
    then: () => Yup.date().required('Please select expected start date')
  }),
  [CUSTOM_CAMPAIGN_NAME]: Yup.string().when([CAMPAIGN_NAME_OPTION, LIST_ITEM_OPTION], {
    is: (campaignNameOption, listItemOption) =>
      campaignNameOption === CUSTOM_CAMPAIGN_NAME_OPTION && listItemOption === OPTION_NEW_LIST_ITEM,
    then: () => Yup.string().required('Please enter custom campaign name')
  })
}

export const campaignObjectiveValidation = {
  [OBJECTIVE]: Yup.string().when(LIST_ITEM_OPTION, {
    is: OPTION_NEW_LIST_ITEM,
    then: () => Yup.string().required('Please select goal')
  })
}

export const getBudgetValidation = ({ remainingBudget, currencySymbol }) =>
  Yup.number()
    .max(remainingBudget, `Your remaining budget is ${currencySymbol}${formatNumber(remainingBudget, { max: 2 })}`)
    .required('Please enter budget')
